import { Link } from "react-router-dom";
import { User, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { SearchDialog } from "@/components/search/SearchDialog";
import accessibilityIcon from "@/assets/accessibility-icon.svg";

interface HeaderIconsProps {
  isLoggedIn: boolean;
  totalWishlistCount: number;
  th: (key: string, fallback: string) => string;
}

const openAccessibility = () => {
  const uw = (window as any).UserWay;
  if (uw?.widgetOpen) uw.widgetOpen();
};

const ACCESSIBILITY_FILTER =
  "brightness(0) saturate(100%) invert(43%) sepia(12%) saturate(1200%) hue-rotate(10deg) brightness(92%) contrast(88%)";

export const HeaderIconsDesktop = ({ isLoggedIn, totalWishlistCount, th }: HeaderIconsProps) => (
  <div className="hidden lg:flex items-center gap-1">
    <Button variant="ghost" size="icon" className="hover:bg-transparent" asChild>
      <Link
        to={isLoggedIn ? "/profile" : "/auth"}
        aria-label={isLoggedIn ? th("personalArea", "האזור האישי") : th("login", "התחברות")}
      >
        <User className="h-5 w-5 text-primary" strokeWidth={1.5} />
      </Link>
    </Button>
    <Button variant="ghost" size="icon" className="hover:bg-transparent relative" asChild>
      <Link to="/wishlist" aria-label={th("wishlist", "רשימת המועדפים")}>
        <Heart className="h-5 w-5 text-primary" strokeWidth={1.5} />
        {totalWishlistCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {totalWishlistCount}
          </span>
        )}
      </Link>
    </Button>
    <Button
      id="accessibility-btn"
      variant="ghost"
      size="icon"
      className="hover:bg-transparent"
      onClick={openAccessibility}
      aria-label="נגישות"
    >
      <img src={accessibilityIcon} alt="נגישות" className="h-6 w-6" style={{ filter: ACCESSIBILITY_FILTER }} />
    </Button>
    <SearchDialog />
    <CartDrawer />
  </div>
);

export const HeaderIconsMobileRight = () => (
  <div className="flex lg:hidden items-center gap-1">
    <Button
      id="accessibility-btn"
      variant="ghost"
      size="icon"
      className="hover:bg-transparent"
      onClick={openAccessibility}
      aria-label="נגישות"
    >
      <img src={accessibilityIcon} alt="נגישות" className="h-6 w-6" style={{ filter: ACCESSIBILITY_FILTER }} />
    </Button>
    <CartDrawer />
  </div>
);
